// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3eyJi","filesListContainer":"PosDisputesFiles_filesListContainer__2Vol-","filesButton":"PosDisputesFiles_filesButton__1JPS-"};